<label class="field-label" [class.!mb-4]="optionWrapperClass">
  {{ label }}
  @if (isRequired) {
    <span class="text-red-600" aria-hidden="true">*</span>
  }
</label>
@if (options) {
<div class="space-y-2">
  @for (option of options; track option; let i = $index) {
  @if (optionWrapperClass) {
  <div
    [class]="optionWrapperClass"
    [class.card-edge-cut-grey]="control.value === option[valueKey]"
  >
    <label
      class="flex items-center gap-x-6 p-6 z-10 cursor-pointer"
      [class.opacity-50]="isDisabled(option[valueKey])"
      [class.pointer-events-none]="isDisabled(option[valueKey])"
      [class.items-start]="stacked"
    >
    <input
      type="radio"
      [formControl]="control"
      [value]="option[valueKey]"
      [checked]="control.value === option[valueKey]"
      (change)="onValueChange(option[valueKey])"
      class="form-radio h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy"
      [name]="groupName"
    />
    <!-- [disabled]="isDisabled(option[valueKey]) || disabled" -->
      <span
        class="text-dc-navy"
        [class.flex]="stacked"
        [class.flex-col]="stacked"
      >
        <span [class.font-semibold]="stacked || labelBold">
          @if (translateOptions) {
            {{ option[labelKey] | translate }}
          } @else {
            {{ option[labelKey] }}
          }
        </span>
        @if (stacked && option[descriptionKey]) {
          <span class="mt-1 font-normal text-dc-navy">
            @if (translateOptions) {
              {{ option[descriptionKey] | translate }}
            } @else {
              {{ option[descriptionKey] }}
            }
          </span>
        }
      </span>
    </label>
  </div>
  } @else {
  <label
    class="flex items-center gap-x-2 py-2 cursor-pointer"
    [class.opacity-50]="isDisabled(option[valueKey])"
    [class.pointer-events-none]="isDisabled(option[valueKey])"
    [class.items-start]="stacked"
  >
    <input
      type="radio"
      [formControl]="control"
      [value]="option[valueKey]"
      [checked]="control.value === option[valueKey]"
      (change)="onValueChange(option[valueKey])"
      class="form-radio h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy"
      [name]="groupName"
    />
    <!-- [disabled]="isDisabled(option[valueKey]) || disabled" -->
    <span
      class="text-dc-navy"
      [class.flex]="stacked"
      [class.flex-col]="stacked"
    >
      <span [class.font-semibold]="stacked || labelBold">
        @if (translateOptions) {
          {{ option[labelKey] | translate }}
        } @else {
          {{ option[labelKey] }}
        }
      </span>
      @if (stacked && option[descriptionKey]) {
        <span class="mt-1 font-normal text-dc-navy">
          @if (translateOptions) {
            {{ option[descriptionKey] | translate }}
          } @else {
            {{ option[descriptionKey] }}
          }
        </span>
      }
    </span>
  </label>
  }
  }

  <div class="fields-error-container">
    <!-- Show custom error messages -->
    @if (control.touched && control.invalid) { @for (errorKey of errorKeys;
    track errorKey) { @if (control.hasError(errorKey)) {
    {{
      validationMessages[errorKey] ||
        (errorKey === "required"
          ? ("VALIDATION_MSG.FIELD_REQUIRED" | translate)
          : "Invalid value")
    }}
    } } }
  </div>
</div>
}
